// extracted by mini-css-extract-plugin
export default {"menu-list":"mwV5j","menu-list__title":"dVJC0"};